import React, { Component } from "react";
import _ from "lodash";
import type { OpencageGeocodeResult } from "./GeocoderService";
import forwardGeocode from "./GeocoderService";

// @ts-ignore
import Autocomplete from "react-autocomplete";
import { style } from "typestyle";

const DEBOUNCE_WAIT_TIME = 400;

interface AddressSearchProps {
  onGeocoderResultSelected: (res: OpencageGeocodeResult) => void;
}

interface AddressSearchState {
  address: string;
  pending: boolean;
  geocoderResults: OpencageGeocodeResult[];
}

export default class AddressSearch extends Component<
  AddressSearchProps,
  AddressSearchState
> {
  state: AddressSearchState = {
    address: "",
    pending: false,
    geocoderResults: [],
  };

  handleAddressChange = (address: string) => {
    this.setState(
      {
        address,
      },
      this.requestReverseGeocoding,
    );
  };

  handleSuggestionSelect = (resultTitle: string) => {
    const selectedGeocoderResult = this.state.geocoderResults.filter(
      r => r.title === resultTitle,
    )[0];
    if (!selectedGeocoderResult) {
      return;
    }

    this.props.onGeocoderResultSelected(selectedGeocoderResult);
  };

  requestReverseGeocoding = _.debounce(() => {
    this.setState({ pending: true });
    forwardGeocode(this.state.address)
      .then(results => {
        this.setState({ geocoderResults: results, pending: false });
      })
      .catch(() => {
        this.setState({ geocoderResults: [], pending: false });
      });
  }, DEBOUNCE_WAIT_TIME);

  render() {
    const { address, geocoderResults } = this.state;
    const items = geocoderResults.map(r => ({ label: r.title }));

    return (
      <Autocomplete
        onSelect={this.handleSuggestionSelect}
        onChange={(e: any) => this.handleAddressChange(e.target.value)}
        items={items}
        value={address}
        menuStyle={{
          borderRadius: "3px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
          background: "rgba(255, 255, 255, 0.9)",
          padding: "2px 0",
          fontSize: "90%",
          position: "absolute",
          top: 30,
          left: 0,
        }}
        renderItem={(item: { label: string }, isHighlighted: boolean) => (
          <div style={{ background: isHighlighted ? "lightgray" : "white" }}>
            {item.label}
          </div>
        )}
        renderInput={(props: any) => {
          return (
            <input
              {...props}
              placeholder="Find address.."
              className={style({
                border: "none",
                borderBottom: "1px solid #007AFF",
                padding: "8px 0",
                width: "100%",
                lineHeight: "24px",
                fontSize: "16px",
              })}
            />
          );
        }}
        wrapperStyle={{ position: "relative" }}
        getItemValue={(item: { label: string }) => item.label}
      />
    );
  }
}
